export default {
      id: "triangle_menu-usage",
      viewBox: "0 0 13 13",
      url: "../dist/images/" + "sprite.svg#triangle_menu-usage",
      toString: function () {
        return this.url;
      }
    }